import { gql } from "apollo-boost";

export const GET_RECIPE_TYPE = gql`
    query getRecipeType {
        items: getRecipeType {
            id
            name
            isPyp
        }
    }
`

export const GET_MEDICAL_ARS = gql`
    query getMedicalArs($where: arsMedicalInput) {
        items: getMedicalArs(where: $where) {
            arsId
            arsName
            arsCode
        }
    }
`

export const GET_MEDICAL_PROVIDERS = gql`
    query getMedicalProviders {
        items: getMedicalProviders {
            medicalId
            providerId
            medicalName
            providerName
            exequatur
            speciality
            genderId
        }
    }
`

export const GET_AFFILIATE = gql`
query getAffiliate($where: getAffiliateWhereInput) {
 items: getAffiliates(where: $where) {
  noAffiliate
  fullname
  affiliateCardNumber
  Nss
  affiliateContrat
  birthDate
  status
  statusDesc
  phone
  ErrorNumber
  ErrorMessage
  gender
  Age
  planType
  affiliateId
  Token
  interactionid
  seccionNumber
  medicinePlan
  pypProgram
  aplicaPYP
  gestionPyP
  medicinePlanList {
    IdPlan
    NombrePlan
    IdTipoPlan 
    TipoPlan 
    MontoTope
    Disponible
    FechaRenovacion 
  }
  programPyPList {
    CodigoPrograma
    Programa
    CodigoCirculo
    Circulo
  }
}
}
`
export const GET_ARS_PLANS = gql`
    query getArsPlansInfo($where: arsMedicalInput) {
        items: getArsPlansInfo(where: $where) {
            arsId
            planId
            planName
            planCode
            recipeQuantity
        }
    }
`
export const GET_MOLECULE_PRESCRIPTION = gql`
    query getMoleculePrescriptions($where: arsMedicalInput) {
        items: getMoleculePrescriptions(where: $where) {
            moleculeName
            progranCode 
            molecule1
            concentration1
            unidad1
	        molecule2
            concentration2
	        unidad2
            molecule3
	        concentration3
            unidad3
            code
        }
    }
`

export const GET_DIAGNOSES = gql`
    query getDiagnoses($where: diagnosesInput) {
        items: getDiagnoses(where: $where) {
            id
            code
            description
        }
    }
`;

export const SAVE_PRESCRIPTION = gql`
    mutation procSavePrescription($data: savePrescriptions) {
        resp: procSavePrescription(data: $data) {
            arsId
            patientId
            recipeTypeId
            startDate
            expiryDate
            prescriptionNumber
        }
    }
`

export const GET_PATIENT = gql`
    query getAffiliate($where: AffiliateWhereInput) {
        item: affiliates(where: $where) {
            id
            firstName
            middleName
            lastName
            lastName2
            dateOfBirth
            gender {
                id
                name
            }
        }
    }
`

export const GET_PATIENT_API = gql`
    query getAffiliate($where: AffiliateWhereInput) {
        item: getAfiliateFromApi(where: $where) {
            firstName
            lastName
            lastName2
            dateOfBirth
            gender
        }
    }
`

export const AFFILIATE_VALID = gql`
    query affiliateValid($where: AffiliatePyPInput) {
        resp: getAffiliatePyP(where: $where) {
            errorNumber
            errorMessage
        }
    }
`;

export const GET_DIGITAL_PRESCRIPTION_HISTORY = gql`
    query digitalPrescriptionHistory {
        items: digitalPrescriptionHistory {
            id
            prescriptionNumber
            affiliateFullName
            date
            arsId
            status
        }
    }
`;

export const GET_DIGITAL_PRESCRIPTION_BY_RECIPE_CODE = gql`
    query digitalPrescriptionByRecipeCode($where: arsMedicalInput) {
        items: digitalPrescriptionByRecipeCode(where: $where) {
            startDate
            expiryDate
            medicalName
            medicalSpeciality
            medicalExequatur
            medicalGender
            prescriptionNumber
            affiliateName
            affiliateAge
            affiliateNss
            affiliateGender
            affiliateIdentification
            affiliatePhone
            providerName
            planName
            arsId
            products {
                product {
                    label
                }
                amount
                frecuency
                duration
                total
                doctorNote
            }
        }
    }
`;

export const GET_CANCELATION_REASONS = gql`
  query GetCancelationReasons($filters: FiltersExpression) {
    reasons: getCancelationReasons(filters: $filters) {
      id
      description
    }
  }
`;

export const CANCEL_PRESCRIPTION = gql`
  mutation cancelPrescription($data: cancelPrescriptionInput) {
    resp: cancelPrescription(data: $data)
  }
`;

export const GET_BRANCH_OFFICES_BY_PROVIDER_AND_MEDICAL_USER = gql`
  query medicalStaffProviders($where: MedicalStaffProviderWhereInput) {
    medicalStaffProviders(where: $where) {
        id: Int
        branchOffice {
            id
            name
        }
    }
  }
`

export const GET_PHARMACY_PROVIDER_LOGO = gql`
query byMedicalStaffProviderpharmacyProviderLogo($where: pharmacyProviderLogoInput){
    byMedicalStaffProviderpharmacyProviderLogo(where:$where){
        pharmacyProviderLogo{
            id
            name
            path
            mimetype
        }
    }
}
`

export const GET_PERMISSION_VIEWS_BY_PROFILE = gql`
 query getPermissionViewsByProfile($where: permissionViewsByProfileInput){
    getPermissionViewsByProfile(where:$where){
        name
    }
 }
`


export const GET_PRESCRIPTION_AVAILABLE_BY_DOCTOR = gql`
  query getPrescriptionAvailableByDoctor(
    $where: PrescriptionPurchaseWhereInput
  ) {
    getPrescriptionAvailableByDoctor(where: $where) {
      amount
      pharmacyProviderId
      branchOfficeId
      medicalStaffId
    }
  }
`;

export const GET_APP_ENVIRONMENT = gql`
  query getAppEnvironment {
    getAppEnvironment {
      environment
      isProduction
    }
  }
`;
